import React, {useEffect, useRef, useState} from "react";
import '../../../css/web/UserModalRenew.css'
import useTheme from '../layoutscommon/DarkModeStorage'
import {AiOutlineDoubleRight} from "react-icons/ai";
import '../../../css/Common.css'
import '../../../css/web/DeliveryPriceDetail.css'
import axios from '../../../services/axiosInstance';
import UserAddrBook from "./UserAddrBook";
import {useNavigate} from "react-router-dom";
import MsgSelectModal from "./MsgSelectModal";
import {BiCaretDown} from "react-icons/bi";
import commonClose from '../../../assets/img/commonClose.png'

import {useTranslation} from "react-i18next";
import CommonLoading from "./CommonLoading";
import SaveMsgModal from "./SaveMsgModal";

function DeliveryPriceDetail({
                                 closeDetail,
                                 paySeqnum,
                                 updatePayinfoList,
                                 deliveryDetailSt,
                                 deliveryDetailFalseFn,
                                 updateAppRecinfo,
                                 pathComponent,
                                 selectedShip
                             }) {
    const {t} = useTranslation();
    const [theme] = useTheme();
    const navigate = useNavigate();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');
    const adminToken = localStorage.getItem('adminToken');

    const [isLoading, setIsLoading] = useState(false);
    const [isBtDisabled, setIsBtDisabled] = useState(false);
    const [isRecinfoBtLoading, setIsRecinfoBtLoading] = useState(false);
    const [isCustomBtLoading, setIsCustomBtLoading] = useState(false);

    const [contentsNameCount, setContentsNameCount] = useState(0);
    const [contentsSeqnum, setContentsSeqnum] = useState("");
    const [contentsName, setContentsName] = useState("");
    const [totalQuantity, setTotalQuantity] = useState("");
    const [contentsDollar, setContentsDollar] = useState('');
    const [contentsWon, setContentsWon] = useState('');

    const [contentsNameError, setContentsNameError] = useState(false);
    const [totalQuantityError, setTotalQuantityError] = useState(false);
    const [contentsDollarError, setContentsDollarError] = useState(false);
    const [contentsWonError, setContentsWonError] = useState(false);

    const [ctSaveDoneMessage, setCtSaveDoneMessage] = useState(false);
    const [ctSaveFailMessage, setCtSaveFailMessage] = useState(false);

    const customCurrency = ['KRW', 'USD', 'CAD', 'AUD', 'NZD', 'EUR', 'JPY', 'SGD']
    const [selectedCurrency, setSelectedCurrency] = useState('USD');

    const [dollarShow, setDollarShow] = useState(false);
    const dollarRef = useRef(null);

    const toggleDollarShow = () => {
        setDollarShow(!dollarShow);
    };

    const selectChangeDollar = (e) => {
        setSelectedCurrency(e);
        setDollarShow(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dollarRef.current && !dollarRef.current.contains(event.target)) {
                setDollarShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const contentsNameLengthCheck = (e) => {
        setContentsNameCount(e.target.value.length);
    };
    const contentsNameInputRTCheck = (e) => {
        setContentsNameCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const validContentsName = ((e) => {
        const contentsNmRegex = /^[a-zA-Z ]{2,35}/; /*영문 2~25자*/
        if (!e.target.value || contentsNmRegex.test(e.target.value)) setContentsNameError(false);
        else setContentsNameError(true);
        setContentsName(e.target.value);
    })

    const validTotalQuantity = ((e) => {
        const totalQuantityRegex = /^\d{1,8}$/;
        const inputValue = e.target.value.replace(/,/g, '');

        if (!inputValue) {
            setTotalQuantityError(true);
            setTotalQuantity('');
        } else if (totalQuantityRegex.test(inputValue)) {
            setTotalQuantityError(false);
            setTotalQuantity(inputValue);
        } else {
            setTotalQuantityError(true);
        }
    })

    // 세관신고통화 셀렉트박스
    const formatCurrency = (value) => {
        // 1. 값이 없으면 빈 문자열 반환
        if (value === null || value === undefined || value === '') return '';
        // 2. [핵심] 들어온 값이 숫자일 수 있으므로 강제로 문자열로 변환
        const strValue = String(value);
        // 3. 소수점을 기준으로 분리 (이제 에러가 나지 않습니다)
        const parts = strValue.split('.');
        // 4. 정수 부분에만 콤마 추가
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // 5. 다시 합쳐서 반환
        return parts.join('.');
    };

    // 세관신고금액
    const validContentsDollar = ((e) => {
        // 콤마 제거 후 숫자만 추출
        const inputValue = e.target.value.replace(/,/g, '');

        // [변경] 정규식 수정
        // ^\d+ : 숫자로 시작
        // (\.\d{0,2})? : 소수점이 올 수 있고, 소수점 뒤에 최대 2자리까지 허용 (필요시 {0,4} 등으로 조절)
        // KRW 처럼 정수만 입력해도 통과됨
        const contentsDollarRegex = /^\d+(\.\d{0,2})?$/;

        if (!inputValue) {
            setContentsDollarError(true);
            setContentsDollar('');
        }
        // 입력값이 정규식과 맞거나, 마지막이 소수점('.')으로 끝나는 경우(입력 중) 허용
        else if (contentsDollarRegex.test(inputValue) || inputValue === '.') {
            setContentsDollarError(false);
            setContentsDollar(inputValue);
        } else {
            // 잘못된 입력이라도 지우거나 상태를 업데이트하지 않음 (사용자 경험 유지)
            // 혹은 에러 표시만 함
            // setContentsDollarError(true);
        }
    });

    const validContentsWon = ((e) => {
        const contentsWonRegex = /^\d{1,8}$/;
        const inputValue = e.target.value.replace(/,/g, '');
        if (!inputValue) {
            setContentsWonError(true);
            setContentsWon('');
        } else if (contentsWonRegex.test(inputValue)) {
            setContentsWonError(false);
            setContentsWon(inputValue);
        } else {
            setContentsWonError(true);
        }
    })

    const insrReset = (() => {
        setContentsWon('');
        setContentsWonError(false);
    })

    const contentsNameValidCheck = (e) => {
        validContentsName(e)
        contentsNameLengthCheck(e);
        contentsNameInputRTCheck(e)
    }

    const [insuranceStatus, setInsuranceStatus] = useState(false);
    const [memberInfo, setMemberInfo] = useState([]);

    const [payList, setPayList] = useState([{}]);
    const [appReqList, setAppReqList] = useState({});
    const [prodList, setProdList] = useState([]);
    const [packList, setPackList] = useState([]);
    const [shipInfoList, setShipInfoList] = useState({});
    const [orderSeqnum, setOrderSeqnum] = useState([]);
    const [appRecSeqnum, setAppRecSeqnum] = useState(0);

    const totalFedexExpense = payList[0]?.ttFedexPrice || 0
    const totalFedexEcoExpense = payList[0]?.ttFedexEcoPrice || 0
    const totalEmsExpense = payList[0]?.ttEmsPrice || 0
    const totalEmsPreExpense = payList[0]?.ttEmsPrePrice || 0
    const totalSeaExpense = payList[0]?.ttSeaPrice || 0
    const totalDomExpense = payList[0]?.ttDomPrice || 0
    const totalDhlExpense = payList[0]?.ttDhlPrice || 0
    const totalUpsExpense = payList[0]?.ttUpsPrice || 0
    const totalUpsEcoExpense = payList[0]?.ttUpsEcoPrice || 0
    const totalKpackExpense = payList[0]?.ttKPackPrice || 0
    const totalAirSExpense = payList[0]?.ttAirSPrice || 0

    const totalShipExpense = (
        totalFedexExpense !== 0 ? totalFedexExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
            totalFedexEcoExpense !== 0 ? totalFedexEcoExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                totalEmsPreExpense !== 0 ? totalEmsPreExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                    totalEmsExpense !== 0 ? totalEmsExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                        totalSeaExpense !== 0 ? totalSeaExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                            totalDomExpense !== 0 ? totalDomExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                totalDhlExpense !== 0 ? totalDhlExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                    totalUpsExpense !== 0 ? totalUpsExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                        totalUpsEcoExpense !== 0 ? totalUpsEcoExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                            totalKpackExpense !== 0 ? totalKpackExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                                totalAirSExpense !== 0 ? totalAirSExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
                                                    0)

    const [taxid, setTaxid] = useState("");
    const [recname, setRecname] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [city, setCity] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [telnum, setTelnum] = useState("");

    const [deliveryChoiceError, setDeliveryChoiceError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [taxidError, setTaxidError] = useState("");
    const [recnameError, setRecnameError] = useState("");
    const [address1Error, setAddress1Error] = useState("");
    const [address2Error, setAddress2Error] = useState("");
    const [address3Error, setAddress3Error] = useState("");
    const [cityError, setCityError] = useState("");
    const [zipcodeError, setZipcodeError] = useState("");
    const [telnumError, setTelnumError] = useState("");

    const [recSaveDoneMessage, setRecSaveDoneMessage] = useState(false);
    const [recSaveFailMessage, setRecSaveFailMessage] = useState(false);

    const [nameInputCount, setNameInputCount] = useState(0);
    const [telnumInputCount, setTelnumInputCount] = useState(0);
    const [zipcodeInputCount, setZipcodeInputCount] = useState(0);
    const [address1InputCount, setAddress1InputCount] = useState(0);
    const [address2InputCount, setAddress2InputCount] = useState(0);
    const [address3InputCount, setAddress3InputCount] = useState(0);
    const [cityInputCount, setCityInputCount] = useState(0);

    const selectPayinfoDetail = (async () => {
        setIsLoading(true);
        try {
            await axios({
                method: 'get',
                url: '/order/selectTotalPayInfo/',
                headers: {
                    Authorization: LCAT ? LCAT : SSAT
                },
                params: {
                    seqNum: paySeqnum
                },
            })
                .then((response) => {
                    setPayList(response.data)
                    setAppReqList(response.data[0].appReqDTO)
                    setProdList(response.data[0].orderdtDTO.productsDTO)
                    setMemberInfo(response.data[0].orderdtDTO.memberDTO)
                    setPackList(response.data[0].packListDTO?.productsDTO)
                    setShipInfoList(response.data[0].shipInfoDTO)

                    setContentsNameCount(response.data[0].customsDTO.custContent.length)
                    setContentsSeqnum(response.data[0].customsDTO.seqNum)
                    setContentsName(response.data[0].customsDTO.custContent)
                    setTotalQuantity(response.data[0].customsDTO.custQty)
                    setSelectedCurrency(response.data[0].customsDTO.custCurrency)
                    setContentsDollar(response.data[0].customsDTO.custPrice)
                    setContentsWon(response.data[0].customsDTO.insrPrice)
                    setInsuranceStatus(response.data[0].customsDTO.insrFl)

                    setAppRecSeqnum(response.data[0].appRecDTO.seqnum)
                    const countryData = {
                        value: response.data[0].appRecDTO.countryDTO.countryCode,
                        label: response.data[0].appRecDTO.countryDTO.countryNm + '(' + response.data[0].appRecDTO.countryDTO.countryEngNm + ')'
                    };
                    setSelectedCountry(countryData)
                    setTaxid(response.data[0].appRecDTO.taxid);
                    setRecname(response.data[0].appRecDTO.recname)
                    setNameInputCount(response.data[0].appRecDTO.recname.length)
                    setTelnum(response.data[0].appRecDTO.telnum)
                    setTelnumInputCount(response.data[0].appRecDTO.telnum.length)
                    setZipcode(response.data[0].appRecDTO.zipcode)
                    setZipcodeInputCount(response.data[0].appRecDTO.zipcode.length)
                    setAddress1(response.data[0].appRecDTO.address1)
                    setAddress1InputCount(response.data[0].appRecDTO.address1.length)
                    setAddress2(response.data[0].appRecDTO.address2)
                    setAddress2InputCount(response.data[0].appRecDTO.address2.length)
                    setAddress3(response.data[0].appRecDTO.address3)
                    setAddress3InputCount(response.data[0].appRecDTO.address3.length)
                    setCity(response.data[0].appRecDTO.city)
                    setCityInputCount(response.data[0].appRecDTO.city.length)

                    setOrderSeqnum(response.data[0].orderdtDTO.seqnum)
                })
        } catch (error) {
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    })

    useEffect(() => {
        selectPayinfoDetail();
        selectAllCountry();
    }, [])

    const validation = () => {
        if (!contentsName) setContentsNameError(true);
        if (!totalQuantity) setTotalQuantityError(true);
        if (!contentsDollar) setContentsDollarError(true);
        if (insuranceStatus && !contentsWon) setContentsWonError(true);
        return !!(contentsName && totalQuantity && contentsDollar && (!insuranceStatus || (insuranceStatus && contentsWon)));
    }

    const modifyCustoms = (async () => {
        if (isBtDisabled) return;
        setIsBtDisabled(true);
        setIsCustomBtLoading(true);

        try {
            await axios({
                method: 'post',
                url: '/order/modifyCustoms/',
                data: {
                    seqNum: contentsSeqnum,
                    custContent: contentsName,
                    custQty: totalQuantity,
                    custCurrency: selectedCurrency,
                    custPrice: contentsDollar,
                    insrFl: insuranceStatus,
                    insrPrice: contentsWon === '' ? 0 : contentsWon
                },
                headers: {
                    // Authorization: LCAT ? LCAT : SSAT
                    Authorization: LCAT || SSAT || adminToken
                },
                params: {
                    paySeqnum: paySeqnum,
                }
            })
                .then((response) => {
                    setCtSaveDoneMessage(true);
                    setTimeout(() => setCtSaveDoneMessage(false), 1500);
                    updatePayinfoList(response.data[0]);
                    setPayList(response.data)
                    setIsBtDisabled(false);
                    setIsCustomBtLoading(false);
                })
                .catch((error) => {
                    console.error(error)
                    setCtSaveFailMessage(true);
                    setTimeout(() => setCtSaveFailMessage(false), 1500);
                    setIsBtDisabled(false);
                    setIsCustomBtLoading(false);
                })
        } catch (error) {
            console.error(error)
            setCtSaveFailMessage(true);
            setTimeout(() => setCtSaveFailMessage(false), 1500);
            setIsBtDisabled(false);
            setIsCustomBtLoading(false);
        } finally {
            setIsBtDisabled(false);
            setIsCustomBtLoading(false);
        }
    })

    const valiAndCustomSave = async (e) => {
        validation();
        if (validation()) {
            await modifyCustoms(e);
        }
    }

    // 여기서부터 국가 커스텀셀렉트
    const [countryList, setCountryList] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({value: '', label: t(`ordCrLabel`)});
    const [countryShow, setCountryShow] = useState(false);
    const [filteredCountryList, setFilteredCountryList] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const countryRef = useRef(null);

    const toggleCountryShow = () => {
        setCountryShow(prev => !prev);
    };

    const handleCountryChange = (country, event) => {
        event.stopPropagation();
        setSelectedCountry(country);
        setSearchKeyword(country.label);
        setCountryShow(false);
    };

    const countryNameMapping = {
        'USA': 'United States of America',
        '터키': '튀르키예',
    };

    const handleCountrySearch = (event) => {
        const keyword = event.target.value;
        setSearchKeyword(keyword);

        const mappedKeyword = countryNameMapping[keyword.toUpperCase()] || countryNameMapping[keyword] || keyword;

        const filteredCountries = countryList.filter((country) =>
            country.label.toLowerCase().includes(mappedKeyword.toLowerCase())
        );

        setFilteredCountryList(filteredCountries);

        if (!keyword) {
            setSelectedCountry({value: '', label: t(`ordCrLabel`)});
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (countryRef.current && !countryRef.current.contains(event.target)) {
                setCountryShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    // 여기까지 커스텀 셀렉트

    const selectAllCountry = () => {
        axios.get('/order/selectCountry')
            .then(response => {
                const countries = response.data.map(country => ({
                    value: country.countryCode,
                    label: `${country.countryNm} (${country.countryEngNm})`
                })).sort((a, b) => a.label.localeCompare(b.label));

                setCountryList(countries);
                setFilteredCountryList(countries);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    };

    const postOffice = selectedShip === 'EMS' || selectedShip === 'EMSP' ||
        selectedShip === 'K-Packet' || selectedShip === 'Small-Packet' || selectedShip === 'SEA';
    const SpecialDelivery = selectedShip === 'FedEx' ||selectedShip === 'FedEx-E' ||
        selectedShip === 'UPS' || selectedShip === 'UPS-E' || selectedShip === 'DHL';
    const domesticDelivery = selectedShip === '국내배송';

    const address1Length = postOffice ? 200 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;
    const address2Length = postOffice ? 50 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;
    const address3Length = postOffice ? 50 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;
    const cityLength = postOffice ? 50 : SpecialDelivery ? 35 : domesticDelivery ? 100 : 35;

    const validTextTaxid = ((e) => {
        let taxidRegex;
        taxidRegex = /^[a-zA-Z0-9\s\-.,]{2,25}$/; /*2~25자*/
        if (!e.target.value || taxidRegex.test(e.target.value)) setTaxidError(false);
        else setTaxidError(true);
        setTaxid(e.target.value);
    })
    const validTextRecname = ((e) => {
        const recnameRegex = /^[a-zA-Z ]{2,35}/; /*영문 2~35자*/
        if (!e.target.value || recnameRegex.test(e.target.value)) setRecnameError(false);
        else setRecnameError(true);
        setRecname(e.target.value);
    })
    const validTextAddr1 = ((e) => {
        const Addr1Regex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${address1Length}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || Addr1Regex.test(e.target.value)) setAddress1Error(false);
        else setAddress1Error(true);
        setAddress1(e.target.value);
    })
    const validTextAddr2 = ((e) => {
        const Addr2Regex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${address2Length}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || Addr2Regex.test(e.target.value)) setAddress2Error(false);
        else setAddress2Error(true);
        setAddress2(e.target.value);
    })
    const validTextAddr3 = ((e) => {
        const Addr3Regex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${address3Length}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || Addr3Regex.test(e.target.value)) setAddress3Error(false);
        else setAddress3Error(true);
        setAddress3(e.target.value);
    })
    const validTextCity = ((e) => {
        const cityRegex = new RegExp(`^[a-zA-Z\\d,-/\\s]{2,${cityLength}}$`); // 암호화 // 영문 또는 "-" 또는 "/" 또는 ","만 가능하고 동적 Length값 이하로 입력
        if (!e.target.value || cityRegex.test(e.target.value)) setCityError(false);
        else setCityError(true);
        setCity(e.target.value);
    })
    const validTextZipcode = ((e) => {
        const zipcodeRegex = /^[a-zA-Z\d- ]{3,10}$/; // 암호화 // 영문 또는 숫자 또는 "-" 로만 가능하게 10자리 이하
        if (!e.target.value || zipcodeRegex.test(e.target.value)) setZipcodeError(false);
        else setZipcodeError(true);
        setZipcode(e.target.value);
    })
    const validTextTelnum = ((e) => {
        const telnumRegex = /^[\d-]{5,15}$/; // 암호화 // 숫자 또는 "-" 로만 가능하게 10자리 이하
        if (!e.target.value || telnumRegex.test(e.target.value)) setTelnumError(false);
        else setTelnumError(true);
        setTelnum(e.target.value);
    })

    const nameInputLengthCheck = (e) => {
        setNameInputCount(e.target.value.length);
    };

    const telnumInputLengthCheck = (e) => {
        setTelnumInputCount(e.target.value.length);
    };

    const zipcodeInputLengthCheck = (e) => {
        setZipcodeInputCount(e.target.value.length);
    };

    const address1InputLengthCheck = (e) => {
        setAddress1InputCount(e.target.value.length);
    };

    const address2InputLengthCheck = (e) => {
        setAddress2InputCount(e.target.value.length);
    };

    const address3InputLengthCheck = (e) => {
        setAddress3InputCount(e.target.value.length);
    };

    const cityInputLengthCheck = (e) => {
        setCityInputCount(e.target.value.length);
    };

    const nameInputRTCheck = (e) => {
        setNameInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const telnumInputRTCheck = (e) => {
        setTelnumInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const zipcodeInputRTCheck = (e) => {
        setZipcodeInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const address1InputRTCheck = (e) => {
        setAddress1InputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const address2InputRTCheck = (e) => {
        setAddress2InputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const address3InputRTCheck = (e) => {
        setAddress3InputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const cityInputRTCheck = (e) => {
        setCityInputCount(
            e.target.value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length
        );
    };

    const nameValid = (e) => {
        validTextRecname(e)
        nameInputLengthCheck(e);
        nameInputRTCheck(e)
    }

    const getMaxLengthByPhoneCountry = () => {
        if (selectedCountry.value === "US") return 10;
        return 15;
    };

    const currentMaxLengthPhoneDisplay = `/${getMaxLengthByPhoneCountry()}`;

    const telnumValid = (e) => {
        const {value} = e.target;

        //미국 숫자만 10자리
        if (selectedCountry.value === "US") {
            if (/^\d{0,10}$/.test(value)) {
                validTextTelnum(e);
                telnumInputLengthCheck(e);
                telnumInputRTCheck(e);
            }
            return;
        }

        if (value.length <= 15) {
            validTextTelnum(e)
            telnumInputLengthCheck(e);
            telnumInputRTCheck(e)
        }
    }

    const getMaxLengthByZipcode = () => {
        if (selectedCountry.value === "US") return 5; // 미국
        if (selectedCountry.value === "CA") return 6; // 캐나다
        return 10;
    };

    const currentMaxLengthZipcodeDisplay = `/${getMaxLengthByZipcode()}`;

    const getPlaceholderByZipcode = () => {
        if (selectedCountry.value === "US") return t(`zipcodeInput`);
        return "";
    };

    const zipcodeValid = (e) => {
        const {value} = e.target;

        //미국 숫자만 5자리
        if (selectedCountry.value === "US") {
            if (/^\d{0,5}$/.test(value)) {
                validTextZipcode(e);
                zipcodeInputLengthCheck(e);
                zipcodeInputRTCheck(e);
            }
            return;
        }

        //캐나다 문자숫자 6자리
        if (selectedCountry.value === "CA") {
            if (/^[a-zA-Z0-9]{0,6}$/.test(value)) {
                validTextZipcode(e);
                zipcodeInputLengthCheck(e);
                zipcodeInputRTCheck(e);
            }
            return;
        }

        if (value.length <= 10) {
            validTextZipcode(e);
            zipcodeInputLengthCheck(e);
            zipcodeInputRTCheck(e);
        }
    }

    const address1Valid = (e) => {
        validTextAddr1(e)
        address1InputLengthCheck(e);
        address1InputRTCheck(e)
    }

    const address2Valid = (e) => {
        validTextAddr2(e)
        address2InputLengthCheck(e);
        address2InputRTCheck(e)
    }

    const address3Valid = (e) => {
        validTextAddr3(e)
        address3InputLengthCheck(e);
        address3InputRTCheck(e)
    }

    const cityValid = (e) => {
        validTextCity(e)
        cityInputLengthCheck(e);
        cityInputRTCheck(e)
    }

    const recValidation = () => {
        let isValid = true;

        setTaxidError(false);
        setRecnameError(false);
        setAddress1Error(false);
        setCityError(false);
        setZipcodeError(false);
        setTelnumError(false);
        setCountryError(false);

        if (selectedCountry.value === "ID" && selectedShip !== 'EMS' && !taxid) {
            setTaxidError(true);
            isValid = false;
        }
        if (selectedCountry.value === t(`ordCrLabel`) || !selectedCountry) {
            setCountryError(true);
            isValid = false;
        }
        if (!recname) {
            setRecnameError(true);
            isValid = false;
        }
        if (!address1) {
            setAddress1Error(true);
            isValid = false;
        }
        if (!city) {
            setCityError(true);
            isValid = false;
        }
        if (!zipcode) {
            setZipcodeError(true);
            isValid = false;
        }
        if (!telnum) {
            setTelnumError(true);
            isValid = false;
        }
        return isValid;
    };

    const valiAndApprecSave = async (e) => {
        const isValid = recValidation();
        if (isValid) {
            await modifyApprec(e);
        }
    };

    const modifyApprec = (async () => {
        if (isBtDisabled) return;
        setIsBtDisabled(true);
        setIsRecinfoBtLoading(true);
        try {
            await axios({
                method: 'post',
                url: '/order/modifyApprec/',
                data: {
                    seqnum: appRecSeqnum,
                    crCode: selectedCountry.value,
                    taxid: taxid,
                    recname: recname,
                    telnum: telnum,
                    zipcode: zipcode,
                    address1: address1,
                    address2: address2,
                    address3: address3,
                    city: city,
                },
                headers: {
                    Authorization: LCAT || SSAT || adminToken
                },
                params: {
                    mbNum: memberInfo.mbNum
                }
            })
                .then((response) => {
                    if (pathComponent === "/UserMyPg" || pathComponent === "/btcorpad") {
                        updateAppRecinfo(response.data);
                    }
                    setRecSaveDoneMessage(true);
                    setTimeout(() => setRecSaveDoneMessage(false), 1500);
                    setIsBtDisabled(false);
                    setIsRecinfoBtLoading(false);
                })
                .catch((error) => {
                    console.log("수취인정보 에러 : ", error)
                    setRecSaveFailMessage(true);
                    setTimeout(() => setRecSaveFailMessage(false), 1500);
                    setIsBtDisabled(false);
                    setIsRecinfoBtLoading(false);
                })
        } catch (error) {
            console.log("수취인정보 에러 : ", error)
            setRecSaveFailMessage(true);
            setTimeout(() => setRecSaveFailMessage(false), 1500);
            setIsBtDisabled(false);
            setIsRecinfoBtLoading(false);
        } finally {
            setIsBtDisabled(false);
            setIsRecinfoBtLoading(false);
        }
    })

    const [deliveryDetailAddrSt, setDeliveryDetailAddrSt] = useState(false);

    const deliveryDetailAddrFalseFn = (() => {
        setDeliveryDetailAddrSt(false);
    })

    const addrChoiceData = ((addrSeqnum) => {
        axios({
            method: 'get',
            url: '/member/choiceAddrInfo',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                seqnum: addrSeqnum
            }
        })
            .then((response) => {
                const countryData = {
                    value: response.data.countryDTO.countryCode,
                    label: response.data.countryDTO.countryNm + '(' + response.data.countryDTO.countryEngNm + ')'
                };
                setSelectedCountry(countryData)
                setTaxid(response.data.taxid);
                setRecname(response.data.recname)
                setAddress1(response.data.address1)
                setAddress2(response.data.address2)
                setAddress3(response.data.address3)
                setCity(response.data.city)
                setZipcode(response.data.zipcode)
                setTelnum(response.data.telnum)
                setNameInputCount(response.data.recname.length)
                setAddress1InputCount(response.data.address1.length)
                setAddress2InputCount(response.data.address2.length)
                setAddress3InputCount(response.data.address3.length)
                setCityInputCount(response.data.city.length)
                setZipcodeInputCount(response.data.zipcode.length)
                setTelnumInputCount(response.data.telnum.length)
                deliveryDetailAddrFalseFn();
                fieldErrorClean();
            })
    })

    const fieldErrorClean = () => {
        setTaxidError(false);
        setRecnameError(false)
        setTelnumError(false);
        setZipcodeError(false);
        setAddress1Error(false);
        setAddress2Error(false);
        setAddress3Error(false);
        setCityError(false);
    }

    const [deliveryDetailPayMove, setDeliveryDetailPayMove] = useState(false);
    const deliveryDetailPayMsg1 = t(`dpdMdMsg1`);
    const deliveryDetailPayMsg2 = t(`dpdMdMsg2`);

    const moveDeliveryPay = (() => {
        if (payList.length > 0) {
            navigate(`/UserMyOrderPg/${payList[0].orderdtDTO.orderNumber}`);
        }
    })

    const [doneCopyMsg, setDoneCopyMsg] = useState(null);
    const [doneCopySt, setDoneCopySt] = useState(false);
    const copyOutWayNum = async () => {
        const textToCopy = shipInfoList.outWayNum || '';

        if (!textToCopy) return;

        try {
            // 클립보드에 텍스트 복사
            await navigator.clipboard.writeText(textToCopy);
            setDoneCopyMsg("복사완료!");
            setDoneCopySt(true);
            setTimeout(() => setDoneCopySt(false), 2000);
        } catch (err) {
            console.error('복사 실패:', err);
            setDoneCopyMsg("복사 실패");
            setDoneCopySt(true);
            setTimeout(() => setDoneCopySt(false), 2000);
        }
    }


    // 임시비활성화
    const disableSt = true;

    return (
        <div data-theme={theme} className="md-scope bookContainer font-t-cont" style={{display: "flex", zIndex: "10"}}>
            <div className="bookFrame dpd-frame" style={{
                width: "600px",
                height: "700px",
                top: "calc(25vh - 120px)",
                left: "calc(50vw - 300px)",
                borderRadius: "5px"
            }}>
                <div style={{width: "100%", height: "100%"}}>
                    <div style={{height: "6%"}}>
                        <div style={{
                            height: "100%",
                            fontSize: "23px",
                            border: "solid 1px var(--md-border, lightgray)",
                            display: "flex",
                            paddingLeft: "15px",
                            paddingRight: "15px",
                            boxSizing: "border-box"
                        }}>
                            <div style={{width: "92%", textAlign: "center", marginLeft: "55px"}}>
                                <p className="font-t-title font-s-17 m-t-8 wd-100pc">{deliveryDetailSt ? t(`dpdHeader1`) : t(`dpdHeader2`)}</p> {/*패키지정보 : 배송비상세*/}
                            </div>
                            <div onClick={deliveryDetailSt ? deliveryDetailFalseFn : closeDetail}
                                 style={{width: "8%", textAlign: "center", cursor: "pointer"}}>
                                <img style={{width: "30px", height: "30px", opacity: "0.7"}} src={commonClose} alt=""/>
                            </div>
                        </div>
                    </div>
                    <div style={{height: "94%", overflowY: "scroll"}}>
                        {!payList[0].ttDomPrice > 0 ?
                            <div style={{
                                border: "solid 1px var(--md-border, #EAEAEA)",
                                margin: "50px 15px 40px 15px",
                                borderRadius: "6px"
                            }}>
                                <div style={{
                                    borderBottom: "solid 1px #EAEAEA",
                                    width: "100%",
                                    height: "40px",
                                    display: "flex",
                                    backgroundColor: "var(--md-panel, #F6F6F6)"
                                }}>
                                <span style={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    margin: "0 4px 0 10px",
                                    fontSize: "14px"
                                }}><AiOutlineDoubleRight/></span>
                                    <span style={{
                                        height: "100%",
                                        fontSize: "13px",
                                        display: "flex",
                                        alignItems: "center",
                                        fontWeight: "bold"
                                    }}>{t(`modRefInfo`)}
                                        <span style={{color: "#FF7D48"}}>({t(`essential`)})</span> {/*수취인정보*/}
                                    </span>
                                </div>
                                <div style={{height: "auto", padding: "20px"}}>

                                    {/*국가+주소록 임시비활성화*/}
                                    <div>
                                        <div style={{height: "40px", display: "flex"}}>
                                            <span style={{
                                                width: "18%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "13px"
                                            }}>
                                                <span style={{
                                                    color: "#FF6347",
                                                    fontSize: "13px",
                                                    marginRight: "5px"
                                                }}>*</span>
                                                {t(`modSmallMenu3`)} {/*국가*/}
                                            </span>
                                            <div className=""
                                                 style={{width: "72.5%", marginLeft: "6px", display: "flex"}}>
                                                <div style={{width: "75%"}}>
                                                    <div style={{width: "100%", height: "100%"}}>
                                                        {/*여기서부터 커스텀 국가셀렉트*/}
                                                        <div ref={countryRef}
                                                             className="ht-40 wd-100pc c-point position-relative m-b-20"
                                                             onClick={!disableSt ? toggleCountryShow : undefined}>
                                                            <div
                                                                className="order-rec-country-input display-flex flex-row wd-100pc ht-100pc">
                                                                {selectedCountry.value ? (
                                                                    <div className="wd-15pc text-center align-center-c">
                                                                        <div
                                                                            className={`m-l-6 font-s-20 fi fi-${selectedCountry.value.toLowerCase()}`}/>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className="wd-15pc text-center align-center-c p-l-5">
                                                                        <div
                                                                            className="wd-29 ht-22 text-center font-s-12 m-0-a country-select-flag">?
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <input
                                                                    className="country-select-in-input wd-100pc ht-100pc c-point font-s-13 p-l-15"
                                                                    type="text" placeholder={t(`modSmallMenu3-1`)}
                                                                    autoComplete="nope"
                                                                    value={searchKeyword || (selectedCountry.value ? selectedCountry.label : '') || (selectedCountry.value ? selectedCountry.label : '')}
                                                                    onChange={handleCountrySearch}
                                                                    disabled={disableSt}/>
                                                                <i className="wd-15pc text-center align-center-c font-s-20 p-b-2 font-c-darkgrey">
                                                                    <BiCaretDown/>
                                                                </i>
                                                            </div>
                                                            {countryShow && !disableSt && (
                                                                <div
                                                                    className="country-select-data wd-100pc position-absolute m-t-5">
                                                                    <div className="country-select-data-child">
                                                                        {filteredCountryList.map((country, index) => (
                                                                            <div
                                                                                className="selectCrListBt display-flex c-point p-t-10 p-b-10 p-l-5"
                                                                                key={index}
                                                                                onClick={(event) => handleCountryChange(country, event)}>
                                                                                <div
                                                                                    className={`font-s-17 m-r-8 fi fi-${country.value.toLowerCase()}`}></div>
                                                                                <p className="font-s-15">{country.label}</p>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/*여기까지 커스텀 국가셀렉트*/}
                                                    </div>
                                                </div>
                                                <div style={{width: "25%", display: "flex"}}>
                                                    <button className="admin-btn-A font-s-13 wd-100pc m-l-10"
                                                            onClick={() => setDeliveryDetailAddrSt(true)}
                                                            disabled={disableSt || (!adminToken && payList[0].payStatus !== "PS0")}>{t(`rmmBookBt`)}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {countryError ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {t(`recCrErr`)}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>


                                    {selectedCountry.value === "ID" ?
                                        <div style={{marginTop: "10px"}}>
                                            <div style={{height: "40px", display: "flex"}}>
                                            <span style={{
                                                width: "18%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "13px"
                                            }}>
                                                <span style={{
                                                    color: "#FF6347",
                                                    fontSize: "13px",
                                                    marginRight: "5px"
                                                }}>*</span>
                                                Tax ID</span>
                                                <div className="customContent"
                                                     style={{width: "73%", marginLeft: "6px"}}>
                                                    <input
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            outline: "none",
                                                            border: "solid 1px var(--md-border, #EAEAEA)",
                                                            borderRadius: "3px",
                                                            fontSize: "14px",
                                                            padding: "5px"
                                                        }} value={taxid} onChange={validTextTaxid} maxLength={25}
                                                        disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                                </div>
                                            </div>
                                            {taxidError ?
                                                <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                    <div className="m-a-error-msg font-t-cont font-s-12">
                                                        {t(`recTaxIdErr`)}
                                                    </div>
                                                </div>
                                                :
                                                null
                                            }
                                        </div>
                                        :
                                        null
                                    }
                                    <div style={{marginTop: "10px"}}>
                                        <div style={{height: "40px", display: "flex"}}>
                                            <span style={{
                                                width: "18%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "13px"
                                            }}>
                                                <span style={{
                                                    color: "#FF6347",
                                                    fontSize: "13px",
                                                    marginRight: "5px"
                                                }}>*</span>
                                                {t(`joinLabel5`)}</span>
                                            <div className="customContent" style={{width: "73%", marginLeft: "6px"}}>
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }} value={recname} onChange={nameValid} maxLength={35}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                            </div>
                                            <div style={{
                                                width: "12%",
                                                display: "flex",
                                                fontSize: "13px",
                                                alignItems: "end",
                                                marginRight: "-2px"
                                            }}>
                                        <span style={{
                                            display: "flex",
                                            color: "orangered",
                                            paddingLeft: "3px"
                                        }}>{nameInputCount}</span><span
                                                style={{display: "flex"}}>/35</span>
                                            </div>
                                        </div>
                                        {recnameError ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {t(`recNmErr`)}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    <div style={{marginTop: "10px"}}>
                                        <div style={{height: "40px", display: "flex"}}>
                                            <span style={{
                                                width: "18%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "13px"
                                            }}>
                                                <span style={{
                                                    color: "#FF6347",
                                                    fontSize: "13px",
                                                    marginRight: "5px"
                                                }}>*</span>
                                                {t(`modSmallMenu5`)}</span> {/*연락처*/}
                                            <div className="customContent" style={{width: "73%", marginLeft: "6px"}}>
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }} value={telnum} onChange={telnumValid} maxLength={15}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                            </div>
                                            <div style={{
                                                width: "12%",
                                                display: "flex",
                                                fontSize: "13px",
                                                alignItems: "end",
                                                marginRight: "-2px"
                                            }}>
                                                <span style={{
                                                    display: "flex",
                                                    color: "orangered",
                                                    paddingLeft: "3px"
                                                }}>{telnumInputCount}</span>
                                                <span style={{display: "flex"}}>{currentMaxLengthPhoneDisplay}</span>
                                            </div>
                                        </div>
                                        {telnumError ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {t(`recTellErr`)}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    <div style={{marginTop: "10px"}}>
                                        <div style={{height: "40px", display: "flex"}}>
                                            <span style={{
                                                width: "18%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "13px"
                                            }}>
                                                <span style={{
                                                    color: "#FF6347",
                                                    fontSize: "13px",
                                                    marginRight: "5px"
                                                }}>*</span>
                                                {t(`modSmallMenu6`)}</span>
                                            <div className="customContent" style={{width: "73%", marginLeft: "6px"}}>
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }} placeholder={getPlaceholderByZipcode()}
                                                    value={zipcode} onChange={zipcodeValid} maxLength={10}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                            </div>
                                            <div style={{
                                                width: "12%",
                                                display: "flex",
                                                fontSize: "13px",
                                                alignItems: "end",
                                                marginRight: "-2px"
                                            }}>
                                                <span style={{
                                                    display: "flex",
                                                    color: "orangered",
                                                    paddingLeft: "3px"
                                                }}>{zipcodeInputCount}</span>
                                                <span style={{display: "flex"}}>{currentMaxLengthZipcodeDisplay}</span>
                                            </div>
                                        </div>
                                        {zipcodeError ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {t(`recZipErr`)}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    <div style={{marginTop: "10px"}}>
                                        <div style={{height: "40px", display: "flex"}}>
                                            <span style={{
                                                width: "18%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "11px"
                                            }}>
                                                <span style={{
                                                    color: "#FF6347",
                                                    fontSize: "13px",
                                                    marginRight: "5px"
                                                }}>*</span>
                                                {t(`modSmallMenu7`)}</span> {/*주소1(주/도)*/}
                                            <div className="customContent" style={{width: "73%", marginLeft: "6px"}}>
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }} value={address1} onChange={address1Valid}
                                                    maxLength={address1Length}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                            </div>
                                            <div style={{
                                                width: "12%",
                                                display: "flex",
                                                fontSize: "13px",
                                                alignItems: "end",
                                                marginRight: "-2px"
                                            }}>
                                        <span style={{
                                            display: "flex",
                                            color: "orangered",
                                            paddingLeft: "3px"
                                        }}>{address1InputCount}</span><span
                                                style={{display: "flex"}}>{`/${address1Length}`}</span>
                                            </div>
                                        </div>
                                        {address1Error ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {`${t("recAddrErr1")} 2~${address1Length}${t("recAddrErr2")}`}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    <div style={{marginTop: "10px"}}>
                                        <div style={{height: "40px", display: "flex"}}>
                                            <span style={{
                                                width: "18%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "12px"
                                            }}>{t(`modSmallMenu8`)}</span>
                                            <div className="customContent" style={{width: "73%", marginLeft: "6px"}}>
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }} value={address2} onChange={address2Valid}
                                                    maxLength={address2Length}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                            </div>
                                            <div style={{
                                                width: "12%",
                                                display: "flex",
                                                fontSize: "13px",
                                                alignItems: "end",
                                                marginRight: "-2px"
                                            }}>
                                        <span style={{
                                            display: "flex",
                                            color: "orangered",
                                            paddingLeft: "3px"
                                        }}>{address2InputCount}</span>
                                                <span style={{display: "flex"}}>{`/${address2Length}`}</span>
                                            </div>
                                        </div>
                                        {address2Error ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {`${t("recAddrErr1")} 2~${address2Length}${t("recAddrErr2")}`}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }

                                    </div>
                                    <div style={{marginTop: "10px"}}>
                                        <div style={{height: "40px", display: "flex"}}>
                                            <span style={{
                                                width: "18%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "12px"
                                            }}>{t(`modSmallMenu9`)}</span>
                                            <div className="customContent" style={{width: "73%", marginLeft: "6px"}}>
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }} value={address3} onChange={address3Valid}
                                                    maxLength={address3Length}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                            </div>
                                            <div style={{
                                                width: "12%",
                                                display: "flex",
                                                fontSize: "13px",
                                                alignItems: "end",
                                                marginRight: "-2px"
                                            }}>
                                        <span style={{
                                            display: "flex",
                                            color: "orangered",
                                            paddingLeft: "3px"
                                        }}>{address3InputCount}</span><span
                                                style={{display: "flex"}}>{`/${address3Length}`}</span>
                                            </div>
                                        </div>
                                        {address3Error ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {`${t("recAddrErr1")} 2~${address3Length}${t("recAddrErr2")}`}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    <div style={{marginTop: "10px"}}>
                                        <div style={{height: "40px", display: "flex"}}>
                                            <span style={{
                                                width: "18%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "13px"
                                            }}>
                                            <span style={{
                                                color: "#FF6347",
                                                fontSize: "13px",
                                                marginRight: "5px"
                                            }}>*</span>
                                                {t(`modSmallMenu10`)}</span>
                                            <div className="customContent" style={{width: "73%", marginLeft: "6px"}}>
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }} value={city} onChange={cityValid} maxLength={cityLength}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                            </div>
                                            <div style={{
                                                width: "12%",
                                                display: "flex",
                                                fontSize: "13px",
                                                alignItems: "end",
                                                marginRight: "-2px"
                                            }}>
                                        <span style={{
                                            display: "flex",
                                            color: "orangered",
                                            paddingLeft: "3px"
                                        }}>{cityInputCount}</span><span
                                                style={{display: "flex"}}>{`/${cityLength}`}</span>
                                            </div>
                                        </div>
                                        {cityError ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {`${t("recAddrErr1")} 2~${cityLength}${t("recAddrErr2")}`}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    {recSaveDoneMessage &&
                                        <div className="m-a-error-msg-container wd-100pc m-t-10"
                                             style={{justifyContent: "center"}}>
                                            <div className="m-a-error-msg font-t-cont font-s-13">
                                                {t(`dpdSvMsg1`)} &#128521;
                                            </div>
                                        </div>
                                    }
                                    {recSaveFailMessage &&
                                        <div className="m-a-error-msg-container wd-100pc m-t-10"
                                             style={{justifyContent: "center"}}>
                                            <div className="m-a-error-msg font-t-cont font-s-13">
                                                {t(`dpdSvMsg2`)} &#128514;
                                            </div>
                                        </div>
                                    }
                                    <div style={{
                                        height: "45px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginTop: "10px"
                                    }}>
                                        <style>
                                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                        </style>
                                        <button className="orderItemHandleBt user-center" style={{width: "80px"}}
                                                onClick={valiAndApprecSave}
                                                disabled={isBtDisabled || (!adminToken && payList[0].payStatus !== "PS0")}>
                                            {isRecinfoBtLoading ? (
                                                <div className="smallSpinner"></div>
                                            ) : (
                                                <div>{t(`saveBt`)}</div>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                        }
                        {/*까지*/}
                        {!payList[0].ttDomPrice > 0 ?
                            <div style={{
                                border: "solid 1px var(--md-border, #EAEAEA)",
                                margin: "60px 15px 40px 15px",
                                borderRadius: "6px"
                            }}>
                                <div style={{
                                    borderBottom: "solid 1px #EAEAEA",
                                    width: "100%",
                                    height: "40px",
                                    display: "flex",
                                    backgroundColor: "var(--md-panel, #F6F6F6)"
                                }}>
                                <span style={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    margin: "0 4px 0 10px",
                                    fontSize: "14px"
                                }}><AiOutlineDoubleRight/></span>
                                    <span style={{
                                        height: "100%",
                                        fontSize: "13px",
                                        display: "flex",
                                        alignItems: "center",
                                        fontWeight: "bold"
                                    }}>{t(`dpdHeader3`)}<span
                                        style={{color: "#FF7D48"}}>({t(`essential`)})</span></span>
                                </div>
                                <div style={{height: "auto", padding: "20px"}}>
                                    <div style={{
                                        marginBottom: "15px",
                                        paddingBottom: "20px",
                                        height: "auto",
                                        borderBottom: "solid 1px #EAEAEA",
                                    }}>
                                        <div style={{height: "40px", display: "flex"}}>
                                        <span style={{
                                            width: "23%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            flexShrink: 0,
                                            fontSize: "13px"
                                        }}>{t(`dpdHeader4`)}</span>
                                            <div className="customContent" style={{width: "68%", marginLeft: "6px"}}>
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }} value={contentsName} onChange={contentsNameValidCheck}
                                                    maxLength={50}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                            </div>
                                            <div style={{
                                                width: "12%",
                                                display: "flex",
                                                fontSize: "13px",
                                                alignItems: "end",
                                                marginRight: "-2px"
                                            }}>
                                        <span style={{
                                            display: "flex",
                                            color: "orangered",
                                            paddingLeft: "3px"
                                        }}>{contentsNameCount}</span><span
                                                style={{display: "flex"}}>/35</span>
                                            </div>
                                        </div>
                                        {contentsNameError ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {t(`dpdErr1`)}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                        <div style={{height: "40px", display: "flex", marginTop: "10px"}}>
                                        <span style={{
                                            width: "23%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            flexShrink: 0,
                                            fontSize: "13px"
                                        }}>{t(`dpdHeader5`)}</span>
                                            <div className="customContent" style={{width: "68%", marginLeft: "6px"}}>
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }} value={totalQuantity} onChange={validTotalQuantity} maxLength={5}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/></div>
                                        </div>
                                        {totalQuantityError ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {t(`dpdErr2`)}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                        <div style={{height: "40px", display: "flex", marginTop: "10px"}}>
                                        <span style={{
                                            width: "23%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            flexShrink: 0,
                                            fontSize: "13px"
                                        }}>{t(`dpdHeader6`)}</span>
                                            <div className="customContent" style={{width: "68%", marginLeft: "6px", display: "flex", alignItems: "center"}}>
                                                <input
                                                    type="text"
                                                    style={{
                                                        width: "100%",
                                                        minWidth: 0,
                                                        height: "100%",
                                                        outline: "none",
                                                        border: "solid 1px var(--md-border, #EAEAEA)",
                                                        borderRadius: "3px",
                                                        fontSize: "14px",
                                                        padding: "5px"
                                                    }}
                                                    value={formatCurrency(contentsDollar)}
                                                    onChange={validContentsDollar}
                                                    maxLength={20}
                                                    placeholder={t(`dpdErr3`)}
                                                    disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                                {/*통화 셀렉트박스 (금액 인풋 우측으로 이동 → 금액 필드명 한 줄 유지)*/}
                                                <div ref={dollarRef} className="ht-30 wd-50 position-relative" style={{marginLeft: "6px", flex: "0 0 auto"}}>
                                                    <button className="selectParentBt wd-100pc ht-100pc" onClick={toggleDollarShow}>
                                                        <p style={{
                                                            margin: "0",
                                                            fontSize: "12px",
                                                            padding: "0 5px"
                                                        }}>{selectedCurrency}</p>
                                                    </button>
                                                    {dollarShow ?
                                                        <div style={{
                                                            position: "absolute",
                                                            right: 0,
                                                            width:"200%",
                                                            border: "solid",
                                                            borderWidth: "thin 1px",
                                                            borderColor: "var(--md-border, lightgray)",
                                                            zIndex: 999,
                                                            marginTop: "10px",
                                                            maxHeight: "200px",
                                                            overflowY: "auto",
                                                        }}>
                                                            {customCurrency.map((dollar, index) => (
                                                                <div className="selectChildBt user-center pd10 c-point font-s-12" key={index}
                                                                     onClick={() => selectChangeDollar(dollar)}
                                                                     style={{
                                                                         zIndex: 99,
                                                                     }}>{dollar}</div>
                                                            ))}
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {contentsDollarError ?
                                            <div className="m-a-error-msg-container wd-100pc m-t-5">
                                                <div className="m-a-error-msg font-t-cont font-s-12">
                                                    {t(`dpdErr3`)}
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    <div style={{height: "40px", display: "flex", marginTop: "10px", alignItems: "center"}}>
                                    <span style={{
                                        width: "23%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        flexShrink: 0,
                                        fontSize: "13px"
                                    }}>{t(`dpdHeader7`)}</span>
                                        <div style={{width: "68%", marginLeft: "6px", display: "flex", alignItems: "center", gap: "24px"}}>
                                            <label style={{display: "flex", alignItems: "center", whiteSpace: "nowrap", cursor: "pointer"}}>
                                                <input className="radioButton" type="radio" name="insurance"
                                                       checked={!insuranceStatus}
                                                       onChange={() => setInsuranceStatus(false)}
                                                       onClick={insrReset}
                                                       disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                                <span style={{
                                                    marginLeft: "6px",
                                                    fontSize: "15px"
                                                }}>{t(`dpdLabel1`)}</span>
                                            </label>
                                            <label style={{display: "flex", alignItems: "center", whiteSpace: "nowrap", cursor: "pointer"}}>
                                                <input className="radioButton" type="radio" name="insurance"
                                                       checked={insuranceStatus}
                                                       onChange={() => setInsuranceStatus(true)}
                                                       disabled={!adminToken && payList[0].payStatus !== "PS0"}/>
                                                <span style={{
                                                    marginLeft: "6px",
                                                    fontSize: "15px"
                                                }}>{t(`dpdLabel2`)}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div style={{height: "40px", display: "flex", margin: "10px 0"}}>
                                    <span style={{
                                        width: "23%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        flexShrink: 0,
                                        fontSize: "13px"
                                    }}>{t(`dpdHeader8`)}(KRW)</span>
                                        <div className="customContent" style={{width: "68%", marginLeft: "6px"}}>
                                            <input type="text"
                                                   style={{
                                                       width: "100%",
                                                       height: "100%",
                                                       outline: "none",
                                                       border: "solid 1px var(--md-border, #EAEAEA)",
                                                       borderRadius: "3px",
                                                       fontSize: "13px",
                                                       padding: "5px"
                                                   }}
                                                   value={contentsWon ? parseInt(contentsWon).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''}
                                                   onChange={validContentsWon} maxLength={8} placeholder={t(`dpdErr4`)}
                                                   disabled={!insuranceStatus || (!adminToken && payList[0].payStatus !== "PS0")}/>
                                        </div>
                                    </div>
                                    {contentsWonError ?
                                        <div className="m-a-error-msg-container wd-100pc m-t-5">
                                            <div className="m-a-error-msg font-t-cont font-s-12">
                                                {t(`dpdErr4`)}
                                            </div>
                                        </div>
                                        :
                                        null
                                    }
                                    {ctSaveDoneMessage &&
                                        <div className="m-a-error-msg-container wd-100pc m-t-5"
                                             style={{justifyContent: "center"}}>
                                            <div className="m-a-error-msg font-t-cont font-s-13">
                                                {t(`dpdSvMsg1`)} &#128521;
                                            </div>
                                        </div>
                                }
                                {ctSaveFailMessage &&
                                    <div className="m-a-error-msg-container wd-100pc m-t-5"
                                         style={{justifyContent: "center"}}>
                                        <div className="m-a-error-msg font-t-cont font-s-13">
                                            {t(`dpdSvMsg2`)} &#128514;
                                        </div>
                                    </div>
                                    }
                                    <div style={{
                                        height: "50px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}>
                                        <style>
                                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                        </style>
                                        <button className="orderItemHandleBt user-center" style={{width: "80px"}}
                                                onClick={valiAndCustomSave}
                                                disabled={isBtDisabled || (!adminToken && payList[0].payStatus !== "PS0")}>
                                            {isCustomBtLoading ? (
                                                <div className="smallSpinner"></div>
                                            ) : (
                                                <div>{t(`saveBt`)}</div>
                                            )}
                                        </button>
                                        {/*저장 버튼(보험 세관신고)*/}
                                    </div>

                                </div>
                            </div>
                            :
                            null
                        }
                        <div style={{
                            border: "solid 1px var(--md-border, #EAEAEA)",
                            margin: "60px 15px 40px 15px",
                            borderRadius: "6px"
                        }}>
                            <div style={{
                                borderBottom: "solid 1px #EAEAEA",
                                width: "100%",
                                height: "40px",
                                display: "flex",
                                backgroundColor: "var(--md-panel, #F6F6F6)"
                            }}>
                                <span style={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    margin: "0 4px 0 10px",
                                    fontSize: "14px"
                                }}><AiOutlineDoubleRight/></span>
                                <span style={{
                                    fontSize: "13px",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}>{t(`dpdHeader9`)}</span>
                            </div>
                            {/*무게정보*/}

                            <div style={{padding: "10px"}}>
                                <div className="u-delivery-price-apy-weight-field"><span
                                    style={{
                                        display: "flex",
                                        justifyContent: "center"
                                    }}>{t(`realWt`)}</span><span>{shipInfoList.weight}kg</span>
                                </div>

                                <div className="u-delivery-price-apy-weight-field">
                                    <span>{t(`volWt`)}[{shipInfoList.wid}cm*{shipInfoList.ver}cm*{shipInfoList.hei}cm]</span>
                                    <span>
                                        {payList[0]?.ttFedexPrice > 0 ? shipInfoList.fedexWeight
                                            : payList[0]?.ttUpsPrice > 0 ? shipInfoList.upsWeight
                                                : payList[0]?.ttEmsPrice > 0 ? shipInfoList.emsWeight
                                                    : payList[0]?.ttSeaPrice > 0 ? shipInfoList.seaWeight
                                                        : (
                                                            payList[0]?.orderdtDTO?.shipco === "FedEx" || payList[0]?.orderdtDTO?.shipco === "FedEx-E"
                                                                ? shipInfoList.fedexWeight
                                                                : payList[0]?.orderdtDTO?.shipco === "UPS" || payList[0]?.orderdtDTO?.shipco === "UPS-E"
                                                                    ? shipInfoList.upsWeight
                                                                    : payList[0]?.orderdtDTO?.shipco === "EMS"
                                                                        ? shipInfoList.emsWeight
                                                                        : payList[0]?.orderdtDTO?.shipco === "EMSP"
                                                                            ? shipInfoList.emsPreWeight
                                                                            : payList[0]?.orderdtDTO?.shipco === "SEA"
                                                                                ? shipInfoList.seaWeight
                                                                                : payList[0]?.orderdtDTO?.shipco === "Small-Packet"
                                                                                    ? shipInfoList.airSWeight
                                                                                    : payList[0]?.orderdtDTO?.shipco === "K-Packet"
                                                                                        ? shipInfoList.kpackWeight
                                                                                        : ""
                                                        )
                                        }kg
                                    </span>
                                </div>


                                {payList[0]?.ttFedexPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field"><span>FedEx {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.fedexApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttFedexEcoPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field"><span>FedEx-E {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.fedexEcoApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttUpsPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field"><span>UPS {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.upsApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttUpsEcoPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field"><span>UPS-E {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.upsEcoApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttEmsPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field"><span>EMS {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.emsApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttEmsPrePrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field"><span>EMSP {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.emsPreApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttKPackPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field">
                                        <span>K-Packet {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.kpackApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttAirSPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field">
                                        <span>Small-Packet {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.airSApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttSeaPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field">
                                        <span>SEA {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.seaApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttDomPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field">
                                        <span>{t('ugCont11')} {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.domeApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                                {payList[0]?.ttDhlPrice > 0 ?
                                    <div className="u-delivery-price-apy-weight-field"><span>DHL {t(`appWt`)}</span>
                                        <span
                                            className="u-delivery-price-apy-weight-value">{shipInfoList.dhlApyWeight}kg</span>
                                    </div>
                                    :
                                    null
                                }

                            </div>
                        </div>

                        <div style={{
                            border: "solid 1px var(--md-border, #EAEAEA)",
                            margin: "60px 15px 40px 15px",
                            borderRadius: "6px"
                        }}>
                            <div style={{
                                borderBottom: "solid 1px #EAEAEA",
                                width: "100%",
                                height: "40px",
                                display: "flex",
                                backgroundColor: "var(--md-panel, #F6F6F6)"
                            }}>
                                <span style={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    margin: "0 4px 0 10px",
                                    fontSize: "14px"
                                }}><AiOutlineDoubleRight/></span>
                                <span style={{
                                    height: "100%",
                                    fontSize: "13px",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}>{t(`modPlHeader3`)}</span>
                            </div>
                            {/*해외배송비*/}
                            {/*FedEx*/}
                            {payList[0]?.ttFedexPrice > 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px dimgrey",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}><span style={{
                                        fontSize: "14px",
                                        height: "40px",
                                        paddingTop: "8px",
                                        fontWeight: "bold"
                                    }}>FedEx</span></div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        marginTop: "10px",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`modPlHeader3`)}</span><span>{payList[0]?.fedexPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`fuelScg`)}</span><span>{payList[0]?.fedexFuelSurch?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`deliveryFee`)}</span><span>{payList[0]?.fedexAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`oTx1`)}</span><span>{payList[0]?.fedexCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`etcArea`)}</span><span>{payList[0]?.fedexOutOfArea?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`insrFee`)}</span><span>{payList[0]?.fedexInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`modSHeader7`)}</span><span style={{
                                        color: totalFedexExpense > 0 ? "darkorange" : "black",
                                        fontWeight: totalFedexExpense > 0 ? "bold" : "normal"
                                    }}>{"\u20A9 " + totalFedexExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                        // 추후 택배사와 API 연동예정
                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                            {/*FedEx-E*/}
                            {payList[0]?.ttFedexEcoPrice > 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px dimgrey",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}><span style={{
                                        fontSize: "14px",
                                        height: "40px",
                                        paddingTop: "8px",
                                        fontWeight: "bold"
                                    }}>FedEx-E</span></div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        marginTop: "10px",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`modPlHeader3`)}</span><span>{payList[0]?.fedexEcoPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`fuelScg`)}</span><span>{payList[0]?.fedexEcoFuelSurch?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`deliveryFee`)}</span><span>{payList[0]?.fedexEcoAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`oTx1`)}</span><span>{payList[0]?.fedexEcoCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`etcArea`)}</span><span>{payList[0]?.fedexOutOfArea?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`insrFee`)}</span><span>{payList[0]?.fedexInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`modSHeader7`)}</span><span style={{
                                        color: totalFedexEcoExpense > 0 ? "darkorange" : "black",
                                        fontWeight: totalFedexEcoExpense > 0 ? "bold" : "normal"
                                    }}>{"\u20A9 " + totalFedexEcoExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                        // 추후 택배사와 API 연동예정
                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                            {/*UPS*/}
                            {payList[0]?.ttUpsPrice > 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px darkgray",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}><span style={{
                                        fontSize: "14px",
                                        height: "40px",
                                        paddingTop: "8px",
                                        fontWeight: "bold"
                                    }}>UPS</span></div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        marginTop: "10px",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`modPlHeader3`)}</span><span>{payList[0]?.upsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`fuelScg`)}</span><span>{payList[0]?.upsFuelSurch?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`deliveryFee`)}</span><span>{payList[0]?.upsAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`oTx1`)}</span><span>{payList[0]?.upsCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`etcArea`)}</span><span>{payList[0]?.upsOutOfArea?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`insrFee`)}</span><span>{payList[0]?.upsInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`modSHeader7`)}</span>
                                        <span style={{
                                            color: totalUpsExpense > 0 ? "darkorange" : "black",
                                            fontWeight: totalUpsExpense > 0 ? "bold" : "normal"
                                        }}>{"\u20A9 " + totalUpsExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                            {/*UPS-E*/}
                            {payList[0]?.ttUpsEcoPrice > 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px darkgray",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}><span style={{
                                        fontSize: "14px",
                                        height: "40px",
                                        paddingTop: "8px",
                                        fontWeight: "bold"
                                    }}>UPS-E</span></div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        marginTop: "10px",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`modPlHeader3`)}</span><span>{payList[0]?.upsEcoPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`fuelScg`)}</span><span>{payList[0]?.upsEcoFuelSurch?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`deliveryFee`)}</span><span>{payList[0]?.upsEcoAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`oTx1`)}</span><span>{payList[0]?.upsEcoCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`etcArea`)}</span><span>{payList[0]?.upsOutOfArea?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`insrFee`)}</span><span>{payList[0]?.upsInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`modSHeader7`)}</span>
                                        <span style={{
                                            color: totalUpsEcoExpense > 0 ? "darkorange" : "black",
                                            fontWeight: totalUpsEcoExpense > 0 ? "bold" : "normal"
                                        }}>{"\u20A9 " + totalUpsEcoExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                            {/*EMS*/}
                            {payList[0]?.ttEmsPrice > 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px darkgray",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}><span style={{
                                        fontSize: "14px",
                                        height: "40px",
                                        paddingTop: "8px",
                                        fontWeight: "bold"
                                    }}>EMS</span></div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        marginTop: "10px",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`modPlHeader3`)}</span><span>{payList[0]?.emsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`deliveryFee`)}</span><span>{payList[0]?.emsAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`oTx1`)}</span><span>{payList[0]?.emsCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`insrFee`)}</span><span>{payList[0]?.emsInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`modSHeader7`)}</span>
                                        <span style={{
                                            color: totalEmsExpense > 0 ? "darkorange" : "black",
                                            fontWeight: totalEmsExpense > 0 ? "bold" : "normal"
                                        }}>{"\u20A9 " + totalEmsExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                            {/*EMSP*/}
                            {payList[0]?.ttEmsPrePrice > 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px darkgray",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}><span style={{
                                        fontSize: "14px",
                                        height: "40px",
                                        paddingTop: "8px",
                                        fontWeight: "bold"
                                    }}>EMSP</span></div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        marginTop: "10px",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`modPlHeader3`)}</span><span>{payList[0]?.emsPrePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`deliveryFee`)}</span><span>{payList[0]?.emsPreAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`oTx1`)}</span><span>{payList[0]?.emsPreCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`insrFee`)}</span><span>{payList[0]?.emsPreInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`modSHeader7`)}</span>
                                        <span style={{
                                            color: totalEmsPreExpense > 0 ? "darkorange" : "black",
                                            fontWeight: totalEmsPreExpense > 0 ? "bold" : "normal"
                                        }}>{"\u20A9 " + totalEmsPreExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                            {/*K-Packet*/}
                            {payList[0]?.ttKPackPrice > 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px darkgray",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}><span style={{
                                        fontSize: "14px",
                                        height: "40px",
                                        paddingTop: "8px",
                                        fontWeight: "bold"
                                    }}>K-Packet</span></div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        marginTop: "10px",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`modPlHeader3`)}</span><span>{payList[0]?.kpackPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`deliveryFee`)}</span><span>{payList[0]?.kpackAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`oTx1`)}</span><span>{payList[0]?.kpackCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`insrFee`)}</span><span>{payList[0]?.kpackInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`modSHeader7`)}</span>
                                        <span style={{
                                            color: totalKpackExpense > 0 ? "darkorange" : "black",
                                            fontWeight: totalKpackExpense > 0 ? "bold" : "normal"
                                        }}>{"\u20A9 " + totalKpackExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                            {/*항공소형포장물*/}
                            {payList[0]?.ttAirSPrice > 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px darkgray",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}><span style={{
                                        fontSize: "14px",
                                        height: "40px",
                                        paddingTop: "8px",
                                        fontWeight: "bold"
                                    }}>Small-Packet</span></div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        marginTop: "10px",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`modPlHeader3`)}</span><span>{payList[0]?.airSPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`deliveryFee`)}</span><span>{payList[0]?.airSAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`oTx1`)}</span><span>{payList[0]?.airSCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`insrFee`)}</span><span>{payList[0]?.airSInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`modSHeader7`)}</span>
                                        <span style={{
                                            color: totalAirSExpense > 0 ? "darkorange" : "black",
                                            fontWeight: totalAirSExpense > 0 ? "bold" : "normal"
                                        }}>{"\u20A9 " + totalAirSExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                            {/*선편배송*/}
                            {payList[0]?.ttSeaPrice > 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px darkgray",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}><span style={{
                                        fontSize: "14px",
                                        height: "40px",
                                        paddingTop: "8px",
                                        fontWeight: "bold"
                                    }}>SEA</span></div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        marginTop: "10px",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`modSHeader6`)}</span>
                                        <span>{payList[0]?.seaPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`deliveryFee`)}</span><span>{payList[0]?.seaAddFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`oTx1`)}</span><span>{payList[0]?.seaCusPrepay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}>
                                        <span>{t(`insrFee`)}</span><span>{payList[0]?.seaInsrFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`modSHeader7`)}</span><span style={{
                                        color: totalSeaExpense > 0 ? "darkorange" : "black",
                                        fontWeight: totalSeaExpense > 0 ? "bold" : "normal"
                                    }}>{"\u20A9 " + totalSeaExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"

                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                            {/*국내배송*/}
                            {totalDomExpense !== 0 &&
                                <div style={{margin: "10px"}}>
                                    <div style={{
                                        width: "23%",
                                        height: "35px",
                                        borderBottom: "solid 1px darkgray",
                                        display: "flex",
                                        marginBottom: "5px",
                                    }}>
                                        <span style={{
                                            fontSize: "14px",
                                            height: "40px",
                                            paddingTop: "8px",
                                            fontWeight: "bold"
                                        }}>{t(`domesticTitle`)}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                    }}><span>{t(`ttDmShipPr`)}</span><span style={{
                                        color: totalDomExpense > 0 ? "darkorange" : "black",
                                        fontWeight: totalDomExpense > 0 ? "bold" : "normal"
                                    }}>{totalDomExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>

                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        wordBreak: "break-all",
                                        fontSize: "13px",
                                        marginBottom: "6px"
                                        // 추후 택배사와 API 연동예정
                                    }}><span>{t(`prodTrNum`)}</span>
                                        <span className="font-s-13 fw-bold c-point" onClick={copyOutWayNum}
                                              style={{color: "#89B2E9"}}>{shipInfoList.outWayNum || ''}</span>
                                    </div>
                                </div>
                            }
                        </div>
                        {/*결제정보(결제상태가 완료일 경우에만 보이게 하기*/}
                        <div style={{margin: "60px 15px 0 15px"}}>
                            <div className="ht-40 border-bottom-bt display-flex m-b-5">
                                <p style={{
                                    fontSize: "16px",
                                    height: "100%",
                                    paddingTop: "8px"
                                }}>{t(`modHeader10`)}</p> {/*결제정보*/}
                            </div>
                            {payList[0]?.cardFee > 0 &&
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    wordBreak: "break-all",
                                    padding: "5px",
                                    fontSize: "13px",
                                    margin: "10px 0"
                                }}><span>{t(`bpmTx17`)}</span>
                                    <span>{payList[0]?.cardFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                </div>
                            }
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                fontSize: "13px",
                                marginTop: "6px"
                            }}><span>{t(`myUseDep`)}</span>
                                <span>{payList[0]?.depUsePrice !== 0 ?
                                    <span>- {payList[0]?.depUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}
                                    </span>
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                fontSize: "13px"
                            }}><span>{t(`myUsePt`)}</span><span>{payList[0]?.pointUsePrice !== 0 ?
                                <span>- {payList[0]?.pointUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}</span>
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                fontSize: "13px"
                            }}><span>{t(`dpdCpNm`)}</span><span>{payList[0]?.couponUsePrice !== 0 ?
                                <span>- {payList[0]?.couponUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}</span>
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                fontSize: "13px"
                            }}><span>{t(`appSale`)}</span><span>{payList[0]?.appSalePrice !== 0 ?
                                <span>- {payList[0]?.appSalePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}</span>
                            </div>
                            <div className="font-b" style={{
                                height: "50px",
                                borderBottom: "solid 1px #EAEAEA",
                                display: "flex",
                                alignItems: "end",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                marginBottom: "50px"
                            }}>
                                {/*최종결제금액*/}
                                <span style={{fontSize: "16px"}}>{t(`modFinalPay`)}
                                    {payList[0]?.childFl ?
                                        <span className="font-s-14">({t(`epdHeader13`)})</span> : null}
                                    </span>
                                <span style={{color: "#FFAF34"}}>
                                        {payList[0]?.payStatus === "PS0" ? 0 : payList[0]?.lastPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    {payList[0]?.cardFee > 0 && payList[0]?.payStatus !== "PS0" &&
                                        <span style={{
                                            fontSize: "12px",
                                            color: "var(--md-text-sub, dimgray)"
                                        }}>(+{payList[0]?.cardFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</span>
                                    }
                                    {/*{payList[0]?.payStatus === "PS0" ? 0 : [*/}
                                    {/*        payList[0]?.depUsePrice || 0,*/}
                                    {/*        payList[0]?.pointUsePrice || 0,*/}
                                    {/*        payList[0]?.couponUsePrice || 0*/}
                                    {/*    ].reduce((sum, value) => sum + value, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}*/}
                                    </span>
                            </div>
                        </div>
                        <div style={{
                            border: "solid 1px var(--md-border, #EAEAEA)",
                            margin: "60px 15px 40px 15px",
                            borderRadius: "6px"
                        }}>
                            <div style={{
                                borderBottom: "solid 1px #EAEAEA",
                                width: "100%",
                                height: "40px",
                                display: "flex",
                                backgroundColor: "var(--md-panel, #F6F6F6)"
                            }}>
                                <span style={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    margin: "0 4px 0 10px",
                                    fontSize: "14px"
                                }}><AiOutlineDoubleRight/></span>
                                <span style={{
                                    height: "100%",
                                    fontSize: "13px",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}>{t(`appReq`)}</span>
                            </div>
                            <div style={{
                                display: "flex",
                                minHeight: "40px",
                                borderBottom: "solid 1px #EAEAEA",
                            }}>
                                <div style={{
                                    width: "23%",
                                    borderRight: "solid 1px #EAEAEA",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "14px"
                                }}><p style={{margin: "0", color: "var(--md-text, black)", fontSize: "13px"}}>{t(`reqOp`)}</p></div>
                                <div style={{
                                    width: "80%",
                                    paddingLeft: "5px",
                                    display: "flex",
                                    flexDirection: "column",
                                    fontSize: "13px",
                                    margin: "10px"
                                }}>
                                    {appReqList.tagRemove &&
                                        <span style={{display: "flex"}}>- {t(`modReqCont1`)}</span>
                                    }
                                    {appReqList.shoesBoxRemove &&
                                        <span style={{display: "flex"}}>- {t(`modReqCont2`)}</span>
                                    }
                                    {appReqList.hangerRemove &&
                                        <span style={{display: "flex"}}>- {t(`modReqCont3`)}</span>
                                    }
                                    {appReqList.compressionPack &&
                                        <span style={{display: "flex"}}>- {t(`modReqCont4`)}</span>
                                    }
                                    {appReqList.prodBoxRemove &&
                                        <span style={{display: "flex"}}>- {t(`modReqCont5`)}</span>
                                    }
                                    {appReqList.packingHold &&
                                        <span style={{display: "flex"}}>- {t(`modReqCont6`)}</span>
                                    }
                                    {appReqList.shipPriceDeposipay &&
                                        <span style={{display: "flex"}}>- {t(`modReqCont7`)}</span>
                                    }
                                    {appReqList.shipPriceMessenger &&
                                        <span style={{display: "flex"}}>- {t(`modReqCont8`)}</span>
                                    }
                                    {appReqList.cusPrepayFl &&
                                        <span style={{display: "flex"}}>- {t(`oTx1`)}</span>
                                    }
                                </div>
                            </div>
                            <div style={{display: "flex", minHeight: "40px"}}>
                                <div style={{
                                    width: "23%",
                                    borderRight: "solid 1px #EAEAEA",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "14px"
                                }}><p style={{margin: "0", color: "var(--md-text, black)", fontSize: "13px"}}>{t(`modSmallMenu13`)}</p>
                                </div>
                                <div style={{
                                    width: "80%",
                                    paddingLeft: "5px",
                                    display: "flex",
                                    flexDirection: "column",
                                    fontSize: "13px",
                                    margin: "10px",
                                }}>
                                    <span style={{display: "flex"}}>{appReqList.detailReq}</span>
                                </div>
                            </div>
                        </div>
                        <div style={{
                            border: "solid 1px var(--md-border, #EAEAEA)",
                            margin: "60px 15px 60px 15px",
                            borderRadius: "6px"
                        }}>
                            <div style={{
                                borderBottom: "solid 1px #EAEAEA",
                                width: "100%",
                                height: "40px",
                                display: "flex",
                                backgroundColor: "var(--md-panel, #F6F6F6)"
                            }}>
                                <span style={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    margin: "0 4px 0 10px",
                                    fontSize: "14px"
                                }}><AiOutlineDoubleRight/></span>
                                <span style={{
                                    height: "100%",
                                    fontSize: "13px",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}>{t(`packList`)}</span> {/*패킹리스트*/}
                            </div>
                            <div className="display-flex ht-40 border-bottom-bt font-s-13 font-b">
                                <div className="display-flex just-cont-center wd-10pc align-center"><p></p></div>
                                <div className="display-flex just-cont-center wd-35pc align-center"><p>{t(`prodNm`)}</p>
                                </div>
                                {/*상품명*/}
                                <div className="display-flex just-cont-center wd-25pc align-center"><p>{t(`prodOp`)}</p>
                                </div>
                                {/*옵션*/}
                                <div className="display-flex just-cont-center wd-10pc align-center"><p>{t(`prodQy`)}</p>
                                </div>
                                {/*수량*/}
                                <div className="display-flex just-cont-center wd-20pc align-center"><p>{t(`prodPr`)}</p>
                                </div>
                                {/*상품금액*/}
                            </div>
                            {packList && packList.map((pack, index) => (
                                <div key={index} className="display-flex ht-50 font-s-13">
                                    <div
                                        className="display-flex just-cont-center align-center wd-10pc">{index + 1}</div>
                                    <div className="display-flex align-center wd-35pc p-l-3">
                                        <span style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}>{pack.name}</span>
                                    </div>
                                    <div className="display-flex just-cont-center align-center wd-25pc">
                                        <span style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}>{pack.option}</span>
                                    </div>
                                    <div className="display-flex just-cont-center align-center wd-10pc">
                                        <span>{pack.quantity?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                    <div className="display-flex just-cont-center align-center wd-20pc">
                                        <span>{pack.price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {pathComponent === "/UserMyPg" ?
                            <div style={{
                                width: "100%",
                                height: "60px",
                                position: "sticky",
                                bottom: "0",
                                backgroundColor: "var(--md-surface, white)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                borderTop: "solid 1px #F2F2F2",
                                paddingRight: "10px"
                            }}>
                                <button onClick={() => setDeliveryDetailPayMove(true)}
                                        style={{width: "120px", height: "40px", border: "solid 1px var(--md-border, lightgray)"}}>
                                    <p style={{fontSize: "13px"}}>{t(`payment`)}</p> {/*결제하기*/}
                                </button>
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
            </div>
            {
                deliveryDetailAddrSt ?
                    <UserAddrBook deliveryDetailAddrSt={deliveryDetailAddrSt}
                                  deliveryDetailAddrFalseFn={deliveryDetailAddrFalseFn}
                                  addrChoiceData={addrChoiceData}/>
                    :
                    deliveryDetailPayMove ?
                        <MsgSelectModal deliveryDetailPayMove={deliveryDetailPayMove}
                                        setDeliveryDetailPayMove={setDeliveryDetailPayMove}
                                        moveDeliveryPay={moveDeliveryPay}
                                        deliveryDetailPayMsg1={deliveryDetailPayMsg1}
                                        deliveryDetailPayMsg2={deliveryDetailPayMsg2}/>
                        :
                        isLoading ?
                            <CommonLoading/>
                            :
                            doneCopySt ?
                                <SaveMsgModal message={doneCopyMsg} />
                                :
                                null
            }
        </div>
    )
}

export default DeliveryPriceDetail
